// Hooks / Node modules / Styles

// Reducers / Actions

// Utils / Functions

// Components
import DefaultLayout from "src/layout/standard/primary/DefaultLayout";
import TitleBar from "src/components/base/title-bar/TitleBar";

// Sub-Components
import EducationCardGroup from "./com/EducationCardGroup";

// Data / Images / Icons

function P_Academics() {
  return (
    <DefaultLayout>
        <TitleBar/>

        <EducationCardGroup/>
    </DefaultLayout>
  )
}

export default P_Academics